export default "__VITE_ASSET__DKWBmUoS__"